import { Eye } from 'lucide-react'
import { useReadOnly } from '@/lib/readOnly'

/** One "View only" line on every page for the principal (plan mock-up 1). */
export function ViewOnlyBanner() {
  const readOnly = useReadOnly()
  if (!readOnly) return null
  return (
    <div
      role="status"
      data-testid="view-only-banner"
      className="mb-4 flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 px-4 py-2.5 text-title-sm font-medium text-amber-800"
    >
      <Eye size={16} className="flex-none" />
      View only — as principal you can see every page of your school, but nothing can be changed from this account.
    </div>
  )
}
